import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import validator from 'validator';
import { useAuth } from '../../providers/auth_provider';

export default function AddCategory({ fetchCategories }) {
    const { token } = useAuth();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        image: null,
        description: '',
        keywords: '',
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        if (e.target.name === 'image') {
            setFormData({
                ...formData,
                image: e.target.files[0]
            });
        } else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (validator.isEmpty(formData.name)) {
            newErrors.name = 'Name is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error('Please fix the errors in the form');
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('description', formData.description);
        formDataToSend.append('keywords', formData.keywords);
        formDataToSend.append('image', formData.image);

        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/category/create`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            if (response) {
                toast.success(response.data.message);
                fetchCategories();
                document.getElementById('closeModal').click();
                setFormData({
                    name: '',
                    image: null,
                    description: '',
                    keywords: ''
                });
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div
            className="offcanvas offcanvas-end w-50"
            tabIndex={-1}
            id="offcanvasAddCategory"
            aria-labelledby="offcanvasAddUserLabel"
        >
            <div className="offcanvas-header border-bottom">
                <h5 id="offcanvasAddUserLabel" className="offcanvas-title">
                    Add Category
                </h5>
                <button type="button" id="closeModal" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 h-100">
                <form className="add-new-user pt-0" id="addNewUserForm" onSubmit={handleSubmit}>
                    <div className="form-floating form-floating-outline mb-5">
                        <input
                            type="file"
                            className={`form-control ${errors.image ? 'is-invalid' : ''}`}
                            id="add-category-image"
                            name="image"
                            aria-label="Icon"
                            onChange={handleChange}
                        />
                        <label htmlFor="add-category-image">Icon</label>
                        {errors.image && <div className="invalid-feedback">{errors.image}</div>}
                    </div>
                    <div className="form-floating form-floating-outline mb-5">
                        <input
                            type="text"
                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                            id="add-category-name"
                            name="name"
                            aria-label="Name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                        <label htmlFor="add-category-name">Name</label>
                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="form-floating form-floating-outline mb-5">
                        <textarea
                            type="text"
                            className={`h-50 form-control ${errors.description ? 'is-invalid' : ''}`}
                            id="add-category-description"
                            name="description"
                            aria-label="Description"
                            value={formData.description}
                            onChange={handleChange}
                        />
                        <label htmlFor="add-category-description">Description</label>
                    </div>
                    <div className="form-floating form-floating-outline mb-5">
                        <input
                            type="text"
                            className={`form-control ${errors.keywords ? 'is-invalid' : ''}`}
                            id="add-category-keywords"
                            name="keywords"
                            placeholder="Enter keywords separated by comma"
                            aria-label="Keywords"
                            value={formData.keywords}
                            onChange={handleChange}
                        />
                        <label htmlFor="add-category-keywords">Keywords (comma separated)</label>
                        {errors.keywords && <div className="invalid-feedback">{errors.keywords}</div>}
                    </div>
                    <hr />
                    <button disabled={loading} type="submit" className="btn btn-success me-sm-3 me-1 data-submit">
                        {loading ? 'Please wait' : 'Submit'}
                    </button>
                    <button disabled={loading} type="reset" className="btn btn-outline-secondary" data-bs-dismiss="offcanvas" >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    );
}